import * as A from "fp-ts/Array";
import { flow, identity, pipe } from "fp-ts/function";
import { concatAll } from "fp-ts/Monoid";
import * as R from "fp-ts/Record";
import { first } from "fp-ts/Semigroup";
import * as T from "fp-ts/Tuple";
import lodash from "lodash";
import { NullValue } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import { firstRight } from "../../../fp-utils";
const valueM = R.getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const toStruct = (fields) => ({ fields });
const toListValue = (values) => ({ values });
const defaultValue = {
  numberValue: void 0,
  nullValue: void 0,
  stringValue: void 0,
  boolValue: void 0
};
const convertJsonToList = (json) => pipe(json, A.map(convertJsonToValue), toListValue);
const convertJsonToValue = (json) => firstRight(json, { ...defaultValue, nullValue: NullValue.NULL_VALUE }, [
  [(json2) => typeof json2 === "number", (json2) => ({ ...defaultValue, numberValue: json2 })],
  [(json2) => typeof json2 === "string", (json2) => ({ ...defaultValue, stringValue: json2 })],
  [(json2) => typeof json2 === "boolean", (json2) => ({ ...defaultValue, boolValue: json2 })],
  [
    (json2) => Array.isArray(json2),
    (json2) => ({ ...defaultValue, listValue: convertJsonToList(json2) })
  ],
  [
    (json2) => lodash.isObject(json2),
    (json2) => ({ ...defaultValue, structValue: convertJsonToStruct(json2) })
  ]
]);
const convertJsonToStruct = flow(
  Object.entries,
  A.map(T.bimap(convertJsonToValue, identity)),
  A.map(toRecord),
  concatAll(valueM),
  toStruct
);
export {
  convertJsonToStruct
};
//# sourceMappingURL=convertJsonToStruct.js.map
